import { useState, useRef } from "react";
import LoadingButton from "../../general/Button/Loading";
import exportTableToExcel from "../../../util/excelExport";
import pdfExport from "../../../util/pdfExport";
import { Space, Divider } from "antd";
import FilteredTable from "../../table/filteredTable";

import {
  ReloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";

export default function ListPage({ data, columns, reloader, tableTitles,pagsize=25 }) {
  const [tableData, setTableData] = useState(data);
  const CurrentTable = useRef(tableData);

  //   function ReloadHandeler() {
  //     console.log("reloading");

  //     GetCurrencies().then((response) => {
  //       console.log(response);
  //       const newData = response.map((i) => {
  //         i.key = i.id;
  //         return i;
  //       });
  //       setTableData(newData);
  //     });
  //   }

  function getCurrent(current) {
    CurrentTable.current = current;
  }

  return (
    <>
      <Space style={{ textAlign: "left" }}>
        <LoadingButton title={<ReloadOutlined />} action={reloader} />
        <LoadingButton
          title={<FileExcelOutlined />}
          action={() => {
            console.log("Excel");
            exportTableToExcel(CurrentTable.current, "test001", tableTitles);
          }}
        />
        <LoadingButton
          title={<FilePdfOutlined />}
          action={() => {
            console.log("PDF");
            pdfExport(CurrentTable.current, "test001", tableTitles);
          }}
        />
      </Space>
      <FilteredTable
        id="currencyTBL"
        headers={columns}
        data={tableData}
        currentData={getCurrent}
        pageSize={pagsize}
      />
    </>
  );
}
